
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.645.355a1.199 1.199 0 00-1.703 0L14.4 7.905 9.254 2.753a1.2 1.2 0 00-1.703 0L.355 9.943a1.199 1.199 0 000 1.703 1.199 1.199 0 001.703 0l6.344-6.353 5.145 5.154a1.197 1.197 0 001.703 0l8.395-8.39a1.198 1.198 0 000-1.702z"}})])
          )
        }
      }
    